/**
 * Generated bundle index. Do not edit.
 */

export {VERSION,UpgradeAdapter,UpgradeAdapterRef} from './public_api';
